import { Controller } from "@hotwired/stimulus";
import { isElementOverflowing } from '../src/javascripts/utils';

export default class extends Controller {
  static targets = ['container'];
  static values = {
    expanded: { type: Boolean, default: false }
  }
  connect() {
    this.restrictHeight();
  }

  restrictHeight() {
    if (!this.hasContainerTarget) { return }

    if (isElementOverflowing(this.containerTarget)) {
      this.containerTarget.classList.add('restrict-height')
    }

    if (this.expandedValue) {
      this.expand();
    }
  }

  expand(event = null) {
    if (event) { event.preventDefault() }
    this.containerTarget.classList.add('restrict-height--expanded');
    this.dispatch('expand');
  }

  collapse(event = null) {
    if (event) { event.preventDefault() }
    this.containerTarget.classList.remove('restrict-height--expanded');
    this.dispatch('collapse');
  }

  toggle(event) {
    this.containerTarget.classList.contains('restrict-height--expanded') ? this.expand(event) : this.collapse(event);
  }
}
